<form *ngIf="initialized" [formGroup]="form" class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper [label]="'Name'" [name]="'title'" [colSize]="7">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>
    <app-icon-dropdown
      [formField]="form.get('icon')"
      [colSize]="2"
      [mode]="'fa'"
      formControlName="icon"
      label="Icon"
      name="icon"></app-icon-dropdown>
  </div>

  <div class="grid">
    <app-form-field-wrapper [label]="'Beschreibung'" [name]="'description'">
      <textarea
        pInputTextarea
        id="description"
        formControlName="description"
        class="p-inputtextarea"></textarea>
    </app-form-field-wrapper>
  </div>

  <div class="grid">
    <app-form-field-wrapper
      [label]="'sichtbar'"
      [name]="'visible'"
      [colSize]="4"
      [floatingLabel]="true">
      <p-inputSwitch formControlName="visible"></p-inputSwitch>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'im Spotlight'"
      [name]="'spotlight'"
      [colSize]="4"
      [floatingLabel]="true">
      <p-inputSwitch formControlName="spotlight"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>

  <p-divider />

  <app-header
    icon="fas fa-layer-group"
    text="Themenbereiche"
    sub="Bereiche mit Thema per Drag & Drop nach rechts ziehen, um sie von ihrem Thema zu lösen - sie erscheinen dann automatisch im Fallback-Thema."></app-header>

  <p-pickList
    [showSourceControls]="false"
    [dragdrop]="true"
    [filterBy]="availableCategories.length > 10 ? 'title' : undefined"
    [sourceStyle]="{ height: '25rem' }"
    [targetStyle]="{ height: '25rem' }"
    sourceHeader="Bereiche mit Thema"
    targetHeader="Bereiche ohne Thema (Fallback)"
    (onMoveToTarget)="handleMoveToTarget($event)"
    (onMoveToSource)="handleMoveToSource($event)"
    [target]="unassignedCategories"
    [source]="availableCategories">
    <ng-template let-category pTemplate="item">
      <div class="flex-1 flex flex-column gap-1">
        <div class="flex align-items-center gap-2">
          <i class="fas fa-layer-group"></i>
          <span>{{ category.title }}</span>
        </div>
        @if (getTopicTitles(category._id); as topicTitles) {
          <span class="text-color-secondary text-sm ml-4">{{
            topicTitles
          }}</span>
        }
      </div>
    </ng-template>
  </p-pickList>
</form>
